import { createRequestActions } from "common/helpers/action";

export const initRegistriesKkmPreview = createRequestActions("CP.REGISTRIES.PREVIEW.INIT");
export const scrollRegistriesKkmPreview = createRequestActions("CP.REGISTRIES.PREVIEW.SCROLL");
export const searchRegistriesKkmPreview = createRequestActions("CP.REGISTRIES.PREVIEW.SEARCH");
export const filterRegistriesKkmPreview = createRequestActions("CP.REGISTRIES.PREVIEW.FILTER");
